import React from "react";
import "./service_com_1.css";
import { Link } from "react-router-dom";
const LoveCompatibility = () => {
  return (
    <section className="love-section">
      <div className="love-container">
        {/* Left side — Title */}
        <div className="love-left">
          <h1>
          COMPATIBILITY <br /> MATCHING
          </h1>
        </div>

        {/* Right side — Description + Button */}
        <div className="love-right">
          <p>
            🌹 What YOU’ll GET

          </p>
          <ul><li>Clear compatibility report based on both charts.
</li>

<li>Insight into love life and married life direction.
</li>
<li>Remedies and practical guidance for harmony & understanding.
</li>
<li>Unlimited questions related to love and marriage within your opted time.</li>
</ul>
          {/* <p>
            Bibendum tortor aliquet morbi facilisis. Ut amet etiam adipiscing
            nam enim imperdiet tempus purus porttitor. Suscipit posuere blandit
            fermentum congue.
          </p> */}

              {/* ✅ Use Link instead of <a> and pass the state */}
          <Link
            to="/Book-your-slot"
            state={{ selectedService: "LoveCompatibility" }} // 👈 service key you’ll handle below
          >
            <button className="love-btn">
              BOOK NOW
              <span className="timerectificationpage-cutted-price"> 3000 </span>
              <span className="timerectificationpage-main-offer-price-rate">2100</span>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LoveCompatibility;
